/**
 * API接口配置工具函数
 */
import type { ApiEndpoint } from './types';
import { API_ENDPOINTS } from './index';
import { API_CATEGORIES } from './constants';

/**
 * 根据分类获取接口列表
 */
export const getApisByCategory = (category: string): ApiEndpoint[] => {
  return API_ENDPOINTS.filter(api => api.category === category);
};

/**
 * 根据ID获取接口详情
 */
export const getApiById = (id: string): ApiEndpoint | undefined => {
  return API_ENDPOINTS.find(api => api.id === id);
};

/**
 * 获取所有分类
 */
export const getAllCategories = (): string[] => {
  return Object.values(API_CATEGORIES);
};

